import { FETCH_ACCOUNT_INFO } from '../actions/accountInfo.actions';
import { RESET_STATE } from '../actions/common.actions';

export const accountInfo = (state = [], action) => {
  switch (action.type) {
    case FETCH_ACCOUNT_INFO:
      return action.payload;
    case RESET_STATE:
      return [];
    default:
      return state;
  }
};
